import * as paths from './const';
import * as pages from 'pages';

export const routes = {
  public: [
    // 로그인 - Sign In
    { path: paths.ROUTE_SIGN_IN, component: pages.LazySignInPage },
    // 루트 - Home
    { path: paths.ROUTE_ROOT, component: pages.LazyHomePage }
  ],
  ADMIN: [
    // 루트 - Home
    { path: paths.ROUTE_ROOT, component: pages.LazyHomePage },
    // 사용자 목록
    { path: paths.ROUTE_USER_MANAGEMENT_LIST, component: pages.LazyUserManagementListPage }
  ],
  USER: [
    // 3D 뷰어
    { path: paths.ROUTE_3D_VIEWER, component: pages.LazyThreeDViewerPage }
  ],
  PARTNER: [
    // 루트 - 3D 뷰어
    { path: paths.ROUTE_ROOT, component: pages.LazyThreeDViewerPage },
    // 3D 뷰어
    { path: paths.ROUTE_3D_VIEWER, component: pages.LazyThreeDViewerPage }
  ]
};
